import {
    type TextStyle,
    StyleSheet
} from "react-native";
import type {
    LabelDynamicStyleConstantType,
    LabelTypographyConstantType,
    LabelColorsConstantType,
    LabelDynamicStyleType,
    LabelTypography,
    LabelVariant,
    LabelColors,
    LabelSize
} from "./type";
import type {
    Mutable
} from "../../types";

export const LABEL_TYPOGRAPHY: Record<LabelVariant, Record<LabelSize, keyof NCoreUIKit.Typography>> = {
    label: {
        medium: "labelMediumSize",
        large: "labelLargeSize",
        small: "labelSmallSize"
    },
    body: {
        medium: "bodyMediumSize",
        large: "bodyLargeSize",
        small: "bodySmallSize"
    }
};

export const getLabelTypography = ({
    variant,
    size
}: LabelTypographyConstantType): LabelTypography => {
    return {
        title: LABEL_TYPOGRAPHY[variant][size],
        note: LABEL_TYPOGRAPHY.body[size]
    };
};

export const getLabelColors = ({
    isDisabled,
    titleColor,
    colors
}: LabelColorsConstantType): LabelColors => {
    if(isDisabled) {
        return {
            optionalTextColor: colors.content.text.disabled,
            requiredColor: colors.content.text.danger,
            titleColor: colors.content.text.disabled
        };
    }

    return {
        titleColor: titleColor ?? colors.content.text.high,
        optionalTextColor: colors.content.text.low,
        requiredColor: colors.content.text.danger
    };
};

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "baseline",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    title: {
        flexShrink: 1
    }
});

export const useStyles = ({
    inlineSpaces
}: LabelDynamicStyleConstantType): LabelDynamicStyleType => {
    return {
        optionalText: {
            marginStart: inlineSpaces.subTitle
        } as Mutable<TextStyle>,
        required: {
            marginStart: inlineSpaces.required
        } as Mutable<TextStyle>
    };
};
export default stylesheet;
